import React from 'react';
import { ThingToDoComponent, ThingToDoComponentProps } from '@apps/guest/packages/layout-engine/widgets/Custom/components/ThingToDo/ThingToDoComponent';
import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import { DesignLayoutType, useGetThingsToDoContainersQuery } from '@graphql/generated';
import { Box, Flex } from '@withjoy/joykit';
import { pxToRem } from '@shared/joykit/packages/core/common';
import { ThingsToDoLoadingSkeleton } from '../shared/ThingsToDoLoadingSkeleton';
import { useLayout } from '@apps/guest/packages/layout-engine/layouts/LayoutProvider';

// Tip:
// This is the component that is rendered on the guest site.
export const DefaultThingsToDoGuest = (props: GuestSiteComponentProps) => {
  const { data, loading } = useGetThingsToDoContainersQuery({ fetchPolicy: 'cache-first', batchMode: 'fast', variables: { payload: { eventId: props.data.eventId } } });
  const defaultThingsToDo = data?.getThingsToDoContainers;
  const { layout } = useLayout();
  const designType = layout === DesignLayoutType.aloha ? 'widget' : 'fullRow';
  return (
    <>
      {loading ? (
        <>
          <ThingsToDoLoadingSkeleton />
          <ThingsToDoLoadingSkeleton />
        </>
      ) : (
        defaultThingsToDo &&
        defaultThingsToDo.length > 0 && (
          <Flex
            flexDirection="row"
            flexWrap="wrap"
            gap={pxToRem(24)}
            justifyContent="center"
            width="100%"
          >
            {defaultThingsToDo.map(container => {
              const data: ThingToDoComponentProps = {
                id: container.id,
                title: container.content.poi.title,
                category: container.content.poi.category,
                description: container.content.poi.description,
                image: container.content.poi.image,
                url: container.content.poi.url,
                sortOrder: 0,
                tours: container.content.poi.tours,
                location: container.content.location.city || undefined,
              };
              return (
                <Box
                  key={container.id}
                  flex={['1 1 100%', '1 1 calc(50% - 12px)', '1 1 calc(50% - 12px)']}
                  minWidth={['100%', 'auto', 'auto']}
                >
                  <ThingToDoComponent
                    {...data}
                    layoutType={'sidebar'}
                    designType={designType}
                  />
                </Box>
              );
            })}
          </Flex>
        )
      )}
    </>
  );
};
